import { version } from '../../../../package.json';
import { Chain } from 'viem';

export const roomFooterTextHandler = ({
  chain,
  activeRoomId,
}: {
  chain: Chain;
  activeRoomId: string;
}) => {
  return ` DApp v: ${version} | ${chain?.name} | Room ID: ${activeRoomId}`;
};
